import { FileUpload, type UploadedFile } from '@latitude/file-upload';
import { FormComponentWrapper } from 'components/FormComponentWrapper';
import type { FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import type { FormFileUploadProps } from './types';

export const FormFileUpload = <T extends FieldValues = FieldValues>({
  name,
  control,
  description,
  label,
  wrapperClassname,
  disabled,
  message,
  optional,
  onChange: onFileChange,
  rules,
  error: hasError,
  ...fileUploadProps
}: FormFileUploadProps<T>) => {
  return (
    <Controller
      name={name}
      {...(control
        ? { control }
        : {
            // if undefined, Controller reads from FormProvider
          })}
      rules={rules}
      render={({
        field: { onBlur, onChange, value },
        fieldState: { error },
      }) => (
        <FormComponentWrapper
          disabled={disabled}
          name={name}
          description={description}
          label={label}
          error={error}
          className={wrapperClassname}
          message={message}
          optional={optional}
        >
          <FileUpload
            disabled={disabled}
            onBlur={onBlur}
            onChange={(files: UploadedFile[]) => {
              onChange(files);
              onFileChange?.(files);
            }}
            error={!!error || hasError}
            externalFiles={value}
            {...fileUploadProps}
          />
        </FormComponentWrapper>
      )}
    />
  );
};
